import { useEffect, useState } from "react";
import { WifiOff } from "lucide-react";

export default function OfflineBanner() {
  const [off, setOff] = useState(!navigator.onLine);
  useEffect(() => {
    const on = () => setOff(false);
    const of = () => setOff(true);
    window.addEventListener("online", on);
    window.addEventListener("offline", of);
    return () => { window.removeEventListener("online", on); window.removeEventListener("offline", of); };
  }, []);
  if (!off) return null;
  return (
    <div className="fixed top-0 inset-x-0 z-[60] bg-rose-600 text-white text-sm font-semibold px-4 py-2.5 flex items-center justify-center gap-2 text-center" style={{ paddingTop: "max(0.625rem, env(safe-area-inset-top))" }} role="alert" data-testid="offline-banner">
      <WifiOff size={16} className="shrink-0" /> Connessione assente: nessuna operazione verrà salvata finché la rete non torna.
    </div>
  );
}
